import styled from 'styled-components';
import { LabeledControlMixin } from '../../mixins/components/LabeledControlMixin';
export var StyledLabeledControl = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledLabeledControl",
  componentId: "c11n-8-111-1__sc-47exur-0"
})(["", ""], LabeledControlMixin);